import src from "IMAGE";
export default { src, width: 659, height: 776, blurWidth: 0, blurHeight: 0};
